import React, { useEffect } from 'react';
import axios from 'axios';
import OptionScope from './OptionScope';
import { useSessionKeepAlive } from './SessionKeepAlive';
import './OptionsTrading.css';

/**
 * Options Trading — OptionScope UI only.
 * Bot stays armed in background; other app menus/routes untouched.
 */
const OptionsTrading = () => {
  useSessionKeepAlive();

  useEffect(() => {
    axios.post('/api/automation/enable').catch(() => {});
  }, []);

  return (
    <div className="opt-app opt-app-scope-only">
      <OptionScope pollMs={8000} />
    </div>
  );
};

export default OptionsTrading;
